export const randomString = length => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
};

export const btnFormat = res => {
    let list = [];
    res.forEach(value => {
        if (value.score !== null) {
            value.is_pw = true;
        } else {
            value.is_pw = false;
        }

        list.push(value);
    });
    return list;
};

export const rolePath = () => {
    const role = Number(localStorage.getItem('role'));
    const rolePaths = {
        0: '/admin/index',
        1: '/schooladmin/index',
        2: '/trainadmin/index',
        3: '/teacher/index',
        4: '/student/index',
        5: '/admin/competition',
        6: '/admin/index',
        7: '/admin/logManagement',
    };
    return rolePaths[role];
};

// percent是*百分百之后的小数值
export const formatScore = (score, percent, precision = 2) => {
    const value = score * percent;
    const parts = value.toString().split('.');
    if (parts.length === 2 && parts[1].length > 2) {
        const factor = Math.pow(10, precision);
        return Math.round((value + Number.EPSILON) * factor) / factor;
    }
    return value;
};
